import Rule from './rule';

export default class LowercaseRule extends Rule {
  constructor(ruleText, attribute,active) {
    super(ruleText, attribute,active);
    this.ruleType = 'LOWERCASE';
  }

  run(input) {
    if(typeof input === 'string') {
      return input.toLowerCase();
    }

    return input;
  }
}
